/* EMP - corrige la barra de envio gratis (FoxKit) y la linea "Envio" del carrito lateral y de /cart
   para que usen el SUBTOTAL QUE VE EL CLIENTE (con descuentos por volumen / ofertas FoxKit),
   no cart.total_price. NO apaga FoxKit ni cambia su meta. Probar primero en un tema BORRADOR. */
(function () {
  var FALLBACK_GOAL = 149; // soles; solo se usa si FoxKit no expone su meta (cart-drawer.liquid:140 tambien lo tiene)

  // Meta: la de FoxKit (asi no se desincroniza si Luis la cambia) o, si no existe, la de respaldo.
  function getGoal() {
    var plugins = window.FoxKitPlugins;
    var g = plugins && plugins.CartGoal ? Number(plugins.CartGoal.goal_amount) : NaN;
    return g > 0 ? g : FALLBACK_GOAL;
  }

  // Toma el ULTIMO monto del texto (si hay precio tachado + precio nuevo) y entiende 1,234.56 / 1.234,56 / 1,234.
  function toNumber(txt) {
    var m = String(txt || '').match(/\d[\d.,]*/g);
    if (!m) return NaN;
    var n = m[m.length - 1];
    var dec = Math.max(n.lastIndexOf('.'), n.lastIndexOf(','));
    if (dec > -1 && n.length - dec - 1 <= 2) {
      return parseFloat(n.slice(0, dec).replace(/[.,]/g, '') + '.' + n.slice(dec + 1));
    }
    return parseFloat(n.replace(/[.,]/g, ''));
  }

  function visibleSubtotal(scope) {
    var list = scope.querySelectorAll('[data-cart-subtotal-price]');
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent !== null) return list[i];
    return list[0] || null;
  }

  function setTitle(title, left) {
    var isMobile = window.matchMedia('(max-width: 480px)').matches;
    var head = '¡Te faltan ';
    var amount = 'S/ ' + left.toFixed(2);
    var tail = isMobile ? ' para envío gratis!' : ' para obtener un envío gratis!';
    if (title.textContent === head + amount + tail) return;
    title.textContent = '';
    var strong = document.createElement('strong');
    strong.textContent = amount;
    title.appendChild(document.createTextNode(head));
    title.appendChild(strong);
    title.appendChild(document.createTextNode(tail));
  }

  function fixBar(bar) {
    var scope = bar.closest('m-cart-drawer') || document;
    var sub = visibleSubtotal(scope);
    if (!sub) return;
    var subtotal = toNumber(sub.textContent);
    if (!isFinite(subtotal)) return;
    var goal = getGoal();
    var left = goal - subtotal;
    if (left > 0.005) {
      var title = bar.querySelector('.foxkit-cartgoal__title');
      if (title) setTitle(title, left);
      bar.classList.remove('foxkit-cartgoal--done');
      bar.style.setProperty('--progress', Math.max(0, Math.min(100, (subtotal / goal) * 100)) + '%');
    }
  }

  // La linea "Envio" dice "Gratis" solo si el subtotal visible llega a la meta Y FoxKit no dice que falta monto.
  function fixShipping(scope) {
    var ship = scope.querySelector('.emp-cart-shipping');
    if (!ship) return;
    var val = ship.lastElementChild;
    if (!val) return;
    var sub = visibleSubtotal(scope);
    var subtotal = sub ? toNumber(sub.textContent) : NaN;
    var bar = scope.querySelector('foxkit-cart-goal');
    var short = isFinite(subtotal) && getGoal() - subtotal > 0.005;
    // La barra aun cargando (oculta por FoxKit) no cuenta: evita el parpadeo "Gratis > Se calcula > Gratis".
    var barVisible = !!bar && !bar.hasAttribute('hidden') && !bar.classList.contains('!foxkit-hidden');
    var foxShort = barVisible && !bar.classList.contains('foxkit-cartgoal--done');
    var free = !short && !foxShort;
    var txt = free ? 'Gratis' : 'Se calcula en el siguiente paso';
    if (val.textContent.trim() !== txt) {
      val.className = free ? 'emp-cart-shipping__free' : '';
      val.textContent = txt;
    }
  }

  function fix() {
    var bars = document.querySelectorAll('foxkit-cart-goal');
    for (var i = 0; i < bars.length; i++) fixBar(bars[i]);
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer) fixShipping(drawer);
  }

  function isCountdown(node) {
    var el = node && node.nodeType === 1 ? node : node && node.parentElement;
    return !!(el && el.closest && el.closest('[class*="countdown"], foxkit-cart-countdown'));
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = '@media (max-width: 480px){ .foxkit-cartgoal__title{ font-size:14px !important; } } .foxkit-cartgoal__inner{ margin-top:12px !important; }';
    document.head.appendChild(css);

    var t;
    var obs = new MutationObserver(function (muts) {
      // La cuenta regresiva de FoxKit cambia cada segundo: no cuenta como cambio del carrito.
      for (var i = 0; i < muts.length; i++) {
    if (!isCountdown(muts[i].target)) {
          fix();
          clearTimeout(t); t = setTimeout(fix, 150);
          return;
        }
      }
    });
    var opts = { childList: true, subtree: true, characterData: true };
    // Solo el carrito lateral (cambia unicamente cuando se modifica el carrito)...
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer) obs.observe(drawer, opts);
    // ...y el contenido principal unicamente en la pagina /cart.
    var isCartPage = (window.MinimogSettings && window.MinimogSettings.templateName === 'cart') || /^\/cart\/?$/.test(location.pathname);
    if (isCartPage) {
      var main = document.querySelector('main') || document.getElementById('MainContent');
      if (main) obs.observe(main, opts);
    }
    fix();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
